/** @jsx jsx */

import React from 'react';
import { css as _css } from 'emotion';
import { css, jsx } from '@emotion/core';
import getTopics from 'services/apiHelpers/getTopics';
import TopicPanel from './TopicPanel';

const TopicPortalContainer = props => {
  const topics = getTopics();

  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin: 12px 0 12px 0;
        `}
      >
        {topics
          .filter((t: any) => {
            return !t.props.hiddenFromMenu;
          })
          .map((t: any) => (
            <TopicPanel key={t.id} topic={t} />
          ))}
      </div>
    </div>
  );
};

export default TopicPortalContainer;
